<template>
  <v-container fluid>
    <v-toolbar>
      <v-toolbar-title>{{ $t('LINKS.ITEMS') }} </v-toolbar-title>

      <v-spacer />

      <v-btn dark color="indigo" @click="create()">
        <v-icon left>mdi-plus</v-icon>
        {{ $t('ITEM.NEW') }} {{ $t('LINKS.ITEM') }}
      </v-btn>
    </v-toolbar>

    <v-sheet class="pa-5" tile>
      <documents-links-list-filter :value="filters" @setRequest="setFilters" />

      <documents-links-list
        :meta="meta"
        :documents-links="documentsLinks"
        :options.sync="options"
        @show="show"
      />
    </v-sheet>

    <v-dialog
      v-if="dialog"
      v-model="dialog"
      persistent
      max-width="600"
    >
      <component
        :is="component.name"
        :data="component.data"
        @created="cancelDialogAndRefresh"
        @updated="cancelDialogAndRefresh"
        @cancel="cancelDialog"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import DocumentsLinksList from '../components/DocumentsLinksList.vue';
import DocumentsLinksListFilter from '../components/DocumentsLinksListFilter.vue';
import DataOptions from '@/modules/_global/classes/DataOptions';
import { DocumentsLinksService } from '@/services/documents-links.service';
import { debounce } from 'lodash';

const DEBOUNCE_DELAY = 300;

export default {
  name: 'DocumentsLinksPage',

  components: {
    DocumentsLinksList,
    DocumentsLinksListFilter,
    EditDocumentsLink: () =>
      import('@/modules/documents_links/components/EditDocumentsLink'),
    CreateDocumentsLink: () =>
      import('@/modules/documents_links/components/CreateDocumentsLink')
  },

  data() {
    return {
      meta: {},
      documentsLinks: [],
      filters: {},
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['id'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false
      },
      dialog: false,
      component: null
    };
  },

  computed: {
    preparedOptions() {
      return DataOptions.createFromObject(this.options).toBackendFormat();
    },

    params() {
      return Object.assign({}, this.filters, this.preparedOptions);
    }
  },

  watch: {
    options: {
      deep: true,
      immediate: true,
      handler() {
        this.refreshData();
      }
    },
    filters: {
      deep: true,
      handler() {
        this.options.page = 1;
        this.refreshData();
      }
    }
  },

  methods: {
    refreshData: debounce(function debouncedGetDocumentsLinks() {
      DocumentsLinksService.getList(this.params).then(({ data }) => {
        this.documentsLinks = data.data;
        this.meta = data.meta;
      });
    }, DEBOUNCE_DELAY),

    setFilters(filters) {
      this.filters = filters;
    },

    create() {
      this.dialog = true;
      this.component = {
        name: 'CreateDocumentsLink'
      };
    },

    cancelDialog() {
      this.dialog = false;
      this.component = null;
    },

    cancelDialogAndRefresh() {
      this.refreshData();
      this.cancelDialog();
    },
    show(item) {
      this.dialog = true;
      this.component = {
        name: 'EditDocumentsLink',
        data: item
      };
    }
  }
};
</script>

<style scoped></style>
